import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Media } from "app/bundles/requests/edit-request/photos-select-form/photos-select-form.model";
import { CollapseItem } from "app/bundles/requests/shared/models/collapseItem";
import { EditRequestService } from "app/bundles/requests/shared/services/edit-request.service";
import { CoreService } from "app/core/core.service";
import { first, forkJoin, of, tap } from "rxjs";
import { IMediaPayload } from "../../shared/api-services/event-api/event-api.service";
import { RequestApi } from "../../shared/api-services/request-api/request-api.models";
import { IWorkorderOrServiceRequestSummary } from "../../shared/models/request";

@Component({
  selector: "app-photos-gallery",
  templateUrl: "./photos-gallery-form.component.html",
  styleUrls: ["./photos-gallery-form.component.scss"],
})
export class PhotosGalleryFormComponent implements OnInit {
  @Input() request: IWorkorderOrServiceRequestSummary;
  @Input() listOfMedia: Media[] = [];
  @Input() cancelAction: CollapseItem;
  @Input() afterSaveAction: CollapseItem;

  public galleryForm: UntypedFormGroup;
  private selectedImage: Media;

  @Input() showCancelSaveButtons = true;

  constructor(
    private fb: UntypedFormBuilder,
    private editRequestService: EditRequestService,
    private requestApiService: RequestApi,
    private coreService: CoreService,
  ) {
    this.galleryForm = this.fb.group({});
  }

  ngOnInit(): void {
    this.onAddNewMedia();
  }

  setSelectedImage(image: Media) {
    this.selectedImage = image;
  }

  navigate(forward) {
    const index =
      this.listOfMedia.indexOf(this.selectedImage) + (forward ? 1 : -1);
    if (index >= 0 && index < this.listOfMedia.length) {
      this.selectedImage = this.listOfMedia[index];
    }
  }

  onRemoveMedia(amedia: Media) {
    for (let x = 0; x < this.listOfMedia.length; x++) {
      if (this.listOfMedia[x].deleted === true) {
        this.listOfMedia.splice(x, 1);
        this.selectedImage = undefined;
        break;
      }
    }
  }

  onAddNewMedia() {
    this.listOfMedia.push(<Media>{
      ndx: this.listOfMedia.length,
      photo: "",
      thumbnail: "",
    });
  }

  canAddNewMedia() {
    let hasEmptySpaces = false;

    for (let x = 0; x < this.listOfMedia.length; x++) {
      if (!this.listOfMedia[x].photo) {
        hasEmptySpaces = true;
        break;
      }
    }
    return this.listOfMedia.length < 10 && !hasEmptySpaces;
  }
  /* ----- GENERAL --------- */
  public saveMedia() {
    const actions = this.listOfMedia.map((aMedia: Media) => {
      if (aMedia.photo) {
        return this.requestApiService.addDocumentByWorkorderId(
          this.request.id.toString(),
          {
            type: "photo",
            filecontent: aMedia.photo,
            origin: "INT",
          },
        );
      } else {
        return of(null);
      }
    });

    return forkJoin(actions).pipe(
      tap((x) => {
        if (this.afterSaveAction) {
          this.editRequestService.toggleCollapse(
            this.afterSaveAction.getName(),
          );
        }
      }),
    );
  }

  public prepareMediaPayloadForBatch(): IMediaPayload[] {
    return this.listOfMedia
      .map((aMedia: Media) => {
        if (!aMedia.photo) {
          return undefined;
        }
        return {
          type: "photo",
          filecontent: aMedia.photo,
          origin: "INT",
        };
      })
      .filter((v) => v);
  }

  public saveMediaSubscribed() {
    this.coreService.startSpinner();
    this.saveMedia()
      .pipe(first())
      .subscribe((x) => this.coreService.stopSpinner());
  }

  public closeGallery(): void {
    if (this.cancelAction) {
      this.editRequestService.toggleCollapse(this.cancelAction.getName());
    }
  }
}
